import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import DocsLayout from './components/DocsLayout';
import './styles/docs.css';
import './styles/docsFlatTheme.css';

/**
 * Punto de entrada principal de la aplicación React VeezDocs
 */
export default function App() {
  return (
    <HelmetProvider>
      <DocsLayout />
    </HelmetProvider>
  );
}
